import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.last-index-of.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCreate, fetchUpdate, fetchDetail } from '@/api/PMS/baseInformation/customer';
import cloneDeep from 'lodash/cloneDeep';
import { getToken } from '@/utils/auth'; // getToken from cookie

import { fetchListByType, fetchLinkageTree } from '@/api/PMS/dic/dic';
import { fetchTreeList } from '@/api/PMS/treeList/index.js';
export default {
  props: ['keyValue', 'showDialog', 'houseId'],
  data: function data() {
    var _this = this;

    var fileMustUpload = function fileMustUpload(rule, value, callback) {
      console.log(_this.fileList, 'sssss');

      if (_this.fileList.length === 0) {
        // 未上传文件
        callback("请上传照片");
      }

      callback();
    };

    return {
      rules: {
        upIdList: [{
          required: true,
          message: '请选择上级机构',
          trigger: 'change'
        }],
        files: [{
          required: true,
          validator: fileMustUpload,
          trigger: 'blur'
        }],
        upIdListTwo: [{
          required: true,
          message: '请选择居住房屋地址',
          trigger: 'change'
        }],
        customerType: [{
          required: true,
          message: '请选择客户类别',
          trigger: 'change'
        }],
        lvZhlx: [{
          required: true,
          message: '请选择身份',
          trigger: 'change'
        }],
        customerName: [{
          required: true,
          message: '请输入客户名称',
          trigger: 'blur'
        }],
        userSex: [{
          required: true,
          message: '请选择客户性别',
          trigger: 'change'
        }],
        userCardType: [{
          required: true,
          message: '请选择证件类型',
          trigger: 'change'
        }],
        userCardSerno: [{
          required: true,
          message: '请输入证件号码',
          trigger: 'blur'
        }],
        userPhoneOne: [{
          required: true,
          message: '请输入联系电话',
          trigger: 'blur'
        }],
        companyAccountName: [{
          required: true,
          message: '请输入公司开户名称',
          trigger: 'blur'
        }],
        companyBankAccount: [{
          required: true,
          message: '请输入银行账号',
          trigger: 'blur'
        }],
        companyCreditCode: [{
          required: true,
          message: '请输入统一社会信用代码',
          trigger: 'blur'
        }],
        companyLegal: [{
          required: true,
          message: '请输入法人代表',
          trigger: 'blur'
        }],
        legalPhoneOne: [{
          required: true,
          message: '请输入联系电话',
          trigger: 'blur'
        }],
        companyPhoneFax: [{
          required: true,
          message: '请输入单位传真',
          trigger: 'blur'
        }],
        companyPhone: [{
          required: true,
          message: '请输入公司电话',
          trigger: 'blur'
        }],
        postName: [{
          required: true,
          message: '请输入职业',
          trigger: 'blur'
        }]
      },
      propstree: {
        label: 'name',
        value: 'id',
        children: 'pmsTree'
      },
      linkageTree: {
        label: 'dicName',
        value: 'dicValue',
        children: 'dicList'
      },
      originUpIdList: [],
      originNativeList: [],
      options: [],
      addressOptions: [],
      nativeOptions: [],
      isDisabled: false,
      showPerson: true,
      childData: {
        upIdList: [],
        upIdListTwo: [],
        nativeList: []
      },
      upIdListTwo: [],
      sexOption: [],
      documentOption: [],
      userTypeList: [],
      // 人员管理类别
      nationList: [],
      // 民族
      userTargetList: [],
      // 人员标签
      userHouseSignList: [],
      // 人户分离
      houseTypeList: [],
      // 住户类型
      postTypeList: [],
      // 职业类型
      owerRelationList: [],
      // 与业主关系
      files: [],
      fileList: [],
      changeFileList: [],
      delImg: [],
      dialogImageUrl: '',
      dialogVisible: false,
      importHeaders: {
        'access-token': getToken()
      },
      educationList: [],
      employmentList: []
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
        this.addressOptions = [];
      }
    }
  },
  created: function created() {
    this.uploadUrl = process.env.VUE_APP_UPLOAD;
    this.downloadUrl = process.env.VUE_APP_DOWNLOAD;
    this.loadNationOptions();
    this.loadUserTargetOptions();
    this.loadUserHouseSignOptions();
    this.loadOwerRelationOptions();
    this.loadPostTypeOptions();
    this.loadUserTypeOptions();
    this.loadHouseTypeOptions();
    this.init();
  },
  methods: {
    init: function init() {
      var _this2 = this;

      this.changeFileList = [];
      this.delImg = [];
      this.files = [];
      this.fileList = [];
      this.isDisabled = false;
      this.sexOption = [];
      this.addressOptions = [];
      this.documentOption = [];
      this.loadSexOptions();
      this.loadDocumentOptions();
      this.loadMenuTree();
      this.loadMenuTree1();
      this.loadLinkageTree();
      this.$nextTick(function () {
        _this2.$refs['dataForm'].clearValidate();
      });

      if (this.keyValue > 0) {
        this.isDisabled = true;
        var queryData = {
          id: this.keyValue,
          houseId: this.houseId
        };
        fetchDetail(queryData).then(function (response) {
          _this2.childData = response.data.data;
          _this2.childData.userCardType = String(_this2.childData.userCardType);
          if (_this2.childData.employment !== null) _this2.childData.employment = String(_this2.childData.employment);
          if (_this2.childData.education !== null) _this2.childData.education = String(_this2.childData.education);
          _this2.childData.nativeList = [];

          _this2.childData.nativeList.push(response.data.data.userNativeProvince);

          _this2.childData.nativeList.push(response.data.data.userNativeCity);

          _this2.childData.upIdList = _this2.childData.upIdList.join(',').split(',');
          _this2.childData.deleteUserImgVo = {};
          var list1 = [];

          _this2.childData.upIdListTwo.forEach(function (item) {
            list1.push(item + '');
          });

          list1.unshift(_this2.childData.areaGroupId + '');
          _this2.upIdListTwo = list1;
          _this2.childData.upIdListTwo = list1;
          console.log('this.childData.upIdListTwo', _this2.childData.upIdListTwo); // this.childData.upIdListTwo = ['1','1','1','1',]

          if (_this2.childData.userImgListVos !== null) {
            _this2.childData.userImgListVos.forEach(function (item) {
              var imgData = {
                fileId: item.imgPath,
                fileType: 2,
                id: item.id,
                imgPath: item.imgPath,
                imgId: item.imgId,
                url: _this2.downloadUrl + item.imgPath
              };
              console.log(_this2.imgData, 'ssss');

              _this2.fileList.push(imgData);
            });

            _this2.files = cloneDeep(_this2.fileList);
          }
        });
      } else {
        this.childData = {
          userSex: null,
          marriage: 1,
          customerType: 1,
          userImgListVos: [],
          deleteUserImgVo: {
            ids: []
          }
        };
      }
    },
    getBuildingId: function getBuildingId() {
      console.log(this.childData.upIdListTwo, 'this.childData.length');
    },
    handCreate: function handCreate() {
      var _this3 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          if (_this3.childData.upIdList && _this3.childData.upIdList.length > 0) {
            _this3.childData.areaGroupId = _this3.childData.upIdList[_this3.childData.upIdList.length - 1];
          }

          if (_this3.childData.upIdListTwo && _this3.childData.upIdListTwo.length > 0) {
            _this3.childData.houseId = _this3.childData.upIdListTwo[_this3.childData.upIdListTwo.length - 1];
            _this3.childData.buildingId = _this3.childData.upIdListTwo[_this3.childData.upIdListTwo.length - 3];
            _this3.childData.unintId = _this3.childData.upIdListTwo[_this3.childData.upIdListTwo.length - 2];
            console.log(_this3.childData.houseId, 'this.childData.houseId ');
          }

          if (_this3.childData.nativeList && _this3.childData.nativeList.length > 1) {
            _this3.childData.userNativeCity = _this3.childData.nativeList[_this3.childData.nativeList.length - 1];
            _this3.childData.userNativeProvince = _this3.childData.nativeList[_this3.childData.nativeList.length - 2];
          }

          _this3.childData.changeUserImgVos = _this3.changeFileList;
          _this3.childData.deleteUserImgVo.ids = _this3.delImg;

          if (_this3.keyValue > 0) {
            _this3.originUpIdList = _this3.childData.upIdList;
            _this3.originNativeList = _this3.childData.nativeList;
            delete _this3.childData.upIdList;
            delete _this3.childData.nativeList;

            _this3.childData.changeUserImgVos.forEach(function (item) {
              item.id = _this3.childData.userId;
            });

            fetchUpdate(_this3.childData).then(function (res) {
              if (res.data.code === 200) {
                _this3.$emit('handCancle', true);

                _this3.Alert({
                  alertType: 'update'
                });
              } else {
                _this3.childData.upIdList = _this3.originUpIdList;
                _this3.childData.nativeList = _this3.originNativeList;
              }
            });
          } else {
            _this3.originUpIdList = _this3.childData.upIdList;
            _this3.originNativeList = _this3.childData.nativeList;
            delete _this3.childData.upIdList;
            delete _this3.childData.nativeList;
            console.log(_this3.childData, '[[[[]]]]');
            fetchCreate(_this3.childData).then(function (res) {
              if (res.data.code === 200) {
                _this3.$emit('handCancle', true);

                _this3.Alert({
                  alertType: 'add'
                });
              } else {
                _this3.childData.upIdList = _this3.originUpIdList;
                _this3.childData.nativeList = _this3.originNativeList;
              }
            });
          }
        } else {
          _this3.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    resetForm: function resetForm() {
      if (this.childData.customerType === 1) {
        this.childData = {
          userSex: null,
          marriage: 1,
          customerType: 1
        };
        this.$refs['dataForm'].clearValidate();
      } else {
        this.childData = {
          customerType: 2
        };
        this.$refs['dataForm'].clearValidate();
      }
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false);
    },
    loadMenuTree: function loadMenuTree() {
      var _this4 = this;

      var treeQuery = {
        flag: 1
      };
      fetchTreeList(treeQuery).then(function (response) {
        _this4.options = response.data.data;
      });
    },
    loadMenuTree1: function loadMenuTree1() {
      var _this5 = this;

      var treeQuery = {
        flag: 7
      };
      fetchTreeList(treeQuery).then(function (response) {
        _this5.addressOptions = response.data.data;
      });
    },
    loadLinkageTree: function loadLinkageTree() {
      var _this6 = this;

      fetchLinkageTree().then(function (response) {
        _this6.nativeOptions = response.data.data;
      });
    },
    loadSexOptions: function loadSexOptions() {
      var _this7 = this;

      fetchListByType('user_sex').then(function (r) {
        _this7.sexOption = r.data.data;
        _this7.sexOption = _this7.sexOption.reverse();
      });
    },
    loadDocumentOptions: function loadDocumentOptions() {
      var _this8 = this;

      fetchListByType('user_card_type').then(function (r) {
        _this8.documentOption = r.data.data;
      });
    },
    loadNationOptions: function loadNationOptions() {
      var _this9 = this;

      // 民族
      fetchListByType('nation_type').then(function (res) {
        _this9.nationList = res.data.data;
      });
    },
    loadUserTargetOptions: function loadUserTargetOptions() {
      var _this10 = this;

      // 人员标签
      fetchListByType('user_target').then(function (res) {
        _this10.userTargetList = res.data.data;
      });
    },
    loadUserHouseSignOptions: function loadUserHouseSignOptions() {
      var _this11 = this;

      // 人户分离
      fetchListByType('user_house_sign').then(function (res) {
        _this11.userHouseSignList = res.data.data;
      });
    },
    loadOwerRelationOptions: function loadOwerRelationOptions() {
      var _this12 = this;

      // 与业主关系
      fetchListByType('lvZhlx').then(function (res) {
        _this12.owerRelationList = res.data.data;
        console.log('123', _this12.owerRelationList);
      });
      console.log('123', this.owerRelationList);
    },
    loadPostTypeOptions: function loadPostTypeOptions() {
      var _this13 = this;

      // 职业类型
      fetchListByType('post_type').then(function (res) {
        _this13.postTypeList = res.data.data;
      });
      fetchListByType('party_qualifications').then(function (res) {
        _this13.educationList = res.data.data;
      });
      fetchListByType('employment_type').then(function (res) {
        _this13.employmentList = res.data.data;
      });
    },
    loadUserTypeOptions: function loadUserTypeOptions() {
      var _this14 = this;

      // 人员管理类型
      fetchListByType('user_type').then(function (res) {
        _this14.userTypeList = res.data.data;
      });
    },
    loadHouseTypeOptions: function loadHouseTypeOptions() {
      var _this15 = this;

      // 住户类型
      fetchListByType('lvzhlx').then(function (res) {
        _this15.houseTypeList = res.data.data;
      });
    },
    changeTypeValue: function changeTypeValue(val) {
      var obj = {};
      obj = this.locations.find(function (item) {
        return item.customerType === val;
      });
      this.childData.customerType = obj.dicName;
    },
    changeTowardValue: function changeTowardValue(val) {
      var obj = {};
      obj = this.locations.find(function (item) {
        return item.userCardType === val;
      });
      this.childData.userCardType = obj.dicName;
    },
    handleSuccess: function handleSuccess(response, file) {
      this.fileList.push({
        name: response.data[0].fileName,
        imgName: response.data[0].fileName,
        fileType: this.judgeFileType(file.raw.type),
        imgPath: response.data[0].fileId,
        fileId: response.data[0].fileId
      });
      this.changeFileList.push({
        name: response.data[0].fileName,
        imgName: response.data[0].fileName,
        fileType: this.judgeFileType(file.raw.type),
        imgPath: response.data[0].fileId,
        fileId: response.data[0].fileId
      });
      this.$refs.dataForm.clearValidate('files');
    },
    handleExceed: function handleExceed() {
      this.$message({
        message: '最多只能上传1个文件!',
        type: 'danger'
      });
    },
    handlePreview: function handlePreview(file) {
      if (file.response !== undefined) {
        // 当还未保存到业务逻辑中时的预览图片
        if (file.raw.type === 'image/png' || file.raw.type === 'image/jpeg' || file.raw.type === 'image/jpg') {
          // 当附件是图片的时候在线打开
          this.dialogVisible = true;
          this.dialogImageUrl = this.downloadUrl + file.response.data[0].fileId;
        } else {
          // 当附件是文件的时候在线下载
          this.dialogImageUrl = this.downloadUrl + file.response.data[0].failId;
          this.handleDownload(this.dialogImageUrl, file.name);
        }
      } else {
        // 当已保存到业务逻辑中时的预览图片
        if (file.fileType === 2) {
          // 当附件是图片的时候在线打开
          this.dialogVisible = true;
          this.dialogImageUrl = file.url;
        } else {
          // 当附件是文件的时候在线下载
          this.dialogImageUrl = file.url;
          this.handleDownload(this.dialogImageUrl, file.name);
        }
      }
    },
    // 移除图片之前做的操作
    beforeRemove: function beforeRemove(file, fileList) {// return this.$confirm(`确定移除 ${ file.name }？`)
    },
    beforeUpload: function beforeUpload(file) {
      var extension = file.name.substring(file.name.lastIndexOf('.') + 1);
      extension = extension.toLowerCase();
      var isLt2M = file.size / 1024 / 1024 < 10;
      var fileFormatOK = extension === 'jpg' || extension === 'jpeg' || extension === 'JPEG' || extension === 'png' || extension === 'bmp' || extension === 'gif';

      if (!fileFormatOK) {
        this.$message({
          message: '只支持上传 jpg/jpeg/png/bmp/gif 格式文件!',
          type: 'error'
        });
        return false;
      }

      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 10MB!',
          type: 'error'
        });
        return false;
      }
    },
    // 移除图片
    handleRemove: function handleRemove(file) {
      var _this16 = this;

      var currentUrl = 0; // 获取当前删除文件的fileId

      if (file.response !== undefined) {
        // 文件是新增加的
        currentUrl = file.response.data[0].fileId;
      } else {
        // 文件是旧数据
        currentUrl = file.fileId;
        this.delImg.push(file.imgId);
      }

      this.files.forEach(function (item, index) {
        if (currentUrl === item.fileId) {
          _this16.files.splice(index, 1);

          return;
        }
      });
      this.fileList.forEach(function (item, index) {
        if (currentUrl === item.fileId) {
          _this16.fileList.splice(index, 1);

          return;
        }
      });
      this.changeFileList.forEach(function (item, index) {
        if (currentUrl === item.fileId) {
          _this16.changeFileList.splice(index, 1);

          return;
        }
      });
    },
    // 下载文件
    handleDownload: function handleDownload(url, name) {
      var link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', name);
      document.body.appendChild(link);
      link.click();
    },
    // 判断上传的文件类型，方便数据库保存
    judgeFileType: function judgeFileType(str) {
      if (str === 'image/png' || str === 'image/jpeg' || str === 'image/jpg' || str === 'image/gif' || str === 'image/bmp') {
        return 2;
      } else {
        return 1;
      }
    }
  }
};